/**
 * Кадр «сам себе тревога» — кнопки SOS-пилюли на площадке (City Resilience
 * Hack, 24.09.2026): человек САМ включает режим ЧС для себя (никого не
 * оповещает, см. web/src/ui/sos-bar.tsx), поэтому кадр без подписи и без
 * опасностей — их при живой тревоге добавит движок web-A1 (emergencyHazard/
 * activeHazards), self-frame их не трогает.
 *
 * По форме — как buildDrillFrame (drill.ts): keyId отличает источник кадра
 * ('self' вместо 'drill'), чтобы live.ts не спутал его с живой тревогой
 * площадки и не затёр при следующем опросе alert.json.
 */
import type { EmergencyFrame, EmergencyModeNum } from './frame'

const SELF_FRAME_TTL_S = 3600

/** EVACUATION (0) — «к выходу», SHELTER (1) — «в укрытие»; DRILL сюда не ведёт. */
export type SelfFrameMode = Extract<EmergencyModeNum, 0 | 1>

/** Синтетический кадр SOS: без подписи, час на решение, блоки пустые. */
export function buildSelfFrame(venueId: string, mode: SelfFrameMode): EmergencyFrame {
  const now = Math.floor(Date.now() / 1000)
  return {
    v: 1,
    venue: venueId,
    id: `self-${mode === 1 ? 'shelter' : 'exit'}`,
    seq: 0,
    mode,
    keyId: 'self',
    issued: now,
    expires: now + SELF_FRAME_TTL_S,
    blocksNodes: [],
    blocksEdges: [],
    smokeNodes: [],
    msgId: null,
    sig: new Uint8Array(0),
  }
}
